import request from '@/utils/request'
import URL from './urlTranslator'

// 查询服务码列表
export function getGroupIdentification(params) {
  return request({
    url: URL.groupIdentification,
    method: 'get',
    params
  })
}
// 新增服务码
export function addGroupIdentification(data) {
  return request({
    url: URL.groupIdentification,
    method: 'post',
    data
  })
}
// 删除服务码
export function deleteGroupIdentification(params) {
  return request({
    url: URL.groupIdentification,
    method: 'delete',
    params
  })
}
// 默认服务码
export function defaultGroupIdentification(data) {
  return request({
    url: URL.groupIdentification,
    method: 'put',
    data
  })
}
